import { Action, handleActions } from 'redux-actions';
import flatMap from 'lodash/map';
import { search } from './actions';

interface QueryResults { places: any[]; }
interface QueryMap { [query: string]: QueryResults; }
interface SearchReducers { [actionType: string]: {(state: QueryMap, action: Action<any>): QueryMap };}

import { getDistance } from 'geolib';
// const metersToMiles = (distance) => distance/1000/1.609344;
// const getMiles = (p1, p2) => metersToMiles(geolib.getDistance(p1, p2));

const _QueryReducers: SearchReducers = {
 [search.names.START]: (state, action) => {
	const { keyword } = action.payload;
	// TODO: last_query -> __query_history__
		const query = {
			data: action.payload,
			inProgress: true,
		};
  return {
		...state,
	 [keyword]: query,
	};
    },
    [search.names.COMPLETED]: (state, action) => {
		  const { keyword, places, position, sort } = action.payload;
			const sorted_places = places
				.sort((p1, p2) =>
							(getDistance(p1.location.position, position) - getDistance(p2.location.position, position)))
      const place_ids = flatMap(sorted_places, 'id') as any;
			const currentState = {
				data: place_ids,
				inProgress: false,
			};

        const new_state = {...state, [keyword]: currentState};
        // const new_state = mergeWith({},
				// 		         state,
				// 		         {[keyword]: place_ids},
				// 		         (dst, src) => {if (isArray(src)) return union(dst, src);}
  			// );

      new_state['__latest__'] = place_ids;
			new_state['__history__'] = [...(new_state['__history__'] || []), {keyword, position, sort}]
        return new_state;
    },
	[search.names.REJECTED]: (state, action) => {
		const { keyword } = action.payload;
		const currentState = {inProgress: false, error: true, data: null};
		return {...state, [keyword]: currentState};
	},
	[search.names.CANCELLED]: (state, action) => {
		const { keyword } = action.payload;
		const currentState = {inProgress: false, error: false, data: null};
		return {...state, [keyword]: currentState};
	},
};

const initialState = {};
const QueryReducers = handleActions<QueryMap>(_QueryReducers, initialState as QueryMap);

export default { queries: QueryReducers };

// export default combineReducers({
//     places: PlaceReducers,
//     queries: QueryReducers
// });


// {
// 	search: {
// 		queries: {
// 			[kw:string]: {
// 				places: [],
// 				queryCoords: [],
// 			}
// 		},
// 		lastQuery: {kw, coords},
// 		places: {},

// 	}

// }



// WEBPACK FOOTER //
// ./src/app/models/Search/reducers.ts